import React, {useMemo} from 'react';

import {
  type RunHistoryKeyInfo,
  type RunHistoryKeyType,
} from '../../../types/run';
import {MetricsPicker} from '../../elements/MetricsPicker';
import {type RunsLinePlotConfig} from '../types';

type HistoryKeysYAxisPickerProps = {
  keyInfo: RunHistoryKeyInfo;
  keyTypes: {[key: string]: RunHistoryKeyType};
  yAxisChoices: string[];
  config: RunsLinePlotConfig;
  updateConfig: (config: RunsLinePlotConfig) => void;
};

/**
 * History-keys-backed y-axis picker. Renders `MetricsPicker` from the
 * full history-key set
 */
export const HistoryKeysYAxisPicker = ({
  keyInfo,
  keyTypes,
  yAxisChoices,
  config,
  updateConfig,
}: HistoryKeysYAxisPickerProps) => {
  const metricsPickerConfig = useMemo(
    () => ({
      metricRegex: config.metricRegex,
      metrics: config.metrics,
      useMetricRegex: config.useMetricRegex,
    }),
    [config.metricRegex, config.metrics, config.useMetricRegex]
  );

  return (
    <MetricsPicker
      config={metricsPickerConfig}
      keyInfo={keyInfo}
      keyTypes={keyTypes}
      options={yAxisChoices}
      updateConfig={updateConfig}
    />
  );
};
